<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <cate-table ref="CateTable" @addClick="AddClick" @EditCateClick="EditClick"/>
      </a-col>
    </a-row>

    <a-modal
      v-model:open="EditModelVisible"
      :title="amodelTitle"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <cate-edit
        :cateMod="selCateMod"
        @EditCateComHandle="EditCateCom"
        @CancleEdit="CancleEdit"
      />
    </a-modal>
  </div>
</template>

<script>
import { CateTable, CateEdit } from "./components/index";
export default {
  components: {
    CateTable,
    CateEdit,
  },
  data() {
    return {
      EditModelVisible: false,
      amodelTitle: "分类编辑",
      isMobile: false,
      selCateMod: {
        id: "",
        cateName: "",
        cateState: "",
      },
    };
  },
  created() {
    this.checkIfMobile();
  },
  computed: {
    amodelHeight() {
      return this.isMobile ? "full-modal" : "helf-modal";
    },
    amodelWidth() {
      return this.isMobile ? "100%" : "50%";
    },
  },
  methods: {
    AddClick(cateMod) {
      this.amodelTitle = cateMod.id == "" ? "分类添加" : "分类编辑";
      this.selCateMod = Object.assign(cateMod);
      this.EditModelVisible = true;
    },
    EditClick(cateMod){
      this.amodelTitle = cateMod.id == "" ? "分类添加" : "分类编辑";
      this.selCateMod = Object.assign(cateMod);
      console.log(this.selCateMod);
      this.EditModelVisible = true;
    },
    EditCateCom(cateMod) {
      this.EditModelVisible = false;
      this.$refs.CateTable.GetTableData(this.$refs.CateTable.Query);
    },
    CancleEdit() {
      this.EditModelVisible = false;
    },
    checkIfMobile() {
      // 通常以768px作为移动设备的断点
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>